<template>
  <div class="main-gray-back">
    <van-form @submit="onSubmit">
      <van-field
        v-model="formData.goods_name"
        input-align="right"
        readonly
        name="选择商品"
        label="选择商品"
        placeholder="选择商品"
        :rules="[{ required: true, message: '请选择商品' }]"
        @click="goods_show = true"
      />

      <van-field
        v-model="formData.sku_name"
        readonly
        input-align="right"
        name="选择规格"
        label="选择规格"
        placeholder="选择规格"
        @click="onGoodsSkuPicker"
      />
      <van-field
        v-model="formData.goods_count"
        input-align="right"
        name="商品数量"
        label="商品数量"
        placeholder="商品数量" 
      />
      <van-field
        v-model="formData.goods_price"
        input-align="right"
        name="商品金额"
        label="商品金额"
        placeholder="商品金额" 
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
    <van-popup
      v-model="goods_show"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="goods-box">
        <van-sticky>
          <div class="flex-between">
            <van-search
              style="flex: 1"
              v-model="value"
              placeholder="请输入搜索关键词"
              @input="onSearchInput"
            />
            <van-icon
              @click="onClsoePopup"
              size="0.6rem"
              style="margin-right: 0.2rem"
              color="#323233"
              name="cross"
            />
          </div>
        </van-sticky>

        <van-list v-model="loading" finished-text="没有更多了">
          <van-cell
            v-for="item in goodsOption"
            :key="item.id"
            :title="item.title"
            @click="onGoodsChange(item)"
          />
        </van-list>
      </div>
    </van-popup>
    <!-- 基础用法 -->
    <div class="sku-container">
      <van-sku
        v-model="showSkuPicker"
        :sku="skuData.sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :quota="skuData.quota"
        :quota-used="skuData.quotaUsed"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        :show-add-cart-btn="false"
        buy-text="确定"
        @buy-clicked="onGoodsSkuSave"
      >
        <span slot="sku-stepper"> </span>
      </van-sku>
    </div>
  </div>
</template>
<style scoped>
.goods-box {
  height: 100%;
  width: 100%;
}
.van-cell__value {
  color: #323233 !important;
}
.main-gray-back {
  min-height: 100%;
  background: #efefef;
  overflow: scroll;
}
</style>

<script>
import Vue from "vue";
import {
  Tab,
  Tabs,
  Toast,
  Calendar,
  Field,
  Popup,
  Search,
  List,
  Cell,
  Sticky,
  Icon,
  Sku,
} from "vant";
import LoginDialog from "@/components/LoginDialog.vue";
Vue.use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(Calendar)
  .use(Field)
  .use(Popup)
  .use(Search)
  .use(List)
  .use(Cell)
  .use(Sticky)
  .use(Icon)
  .use(Sku);
export default {
  name: "ConfigureAdd",
  components: {
    LoginDialog,
  },
  data: function () {
    return {
      value: "",
      showSkuPicker: false,
      closeOnClickOverlay: true,
      messageConfig: {},
      loading: false,
      goods_show: false,
      sku_show: false,
      loginShow: false,
      formData: {
        id:0,
        sale_id: 0,
        goods_id: "",
        goods_name: "",
        sku_name: "",
        sku_id: 0,
        goods_count: 0,
        goods_price: 0,
        express_free_status: false,
      },
      goodsOption: [],
      goods_list: [],
      skuData: {
        sku: {
          none_sku: false, // 是否无规格商品
          hide_stock: false, // 是否隐藏剩余库存
          list: [],
          tree: [],
          messages: [],
        },
        goods: {},
        goods_id: 0,
        quota: 0,
        quotaUsed: 0,
      },
    };
  },
  filter: {},
  mounted() {
    document.title = "销售单配置";
    this.formData.id = parseInt(this.$route.query.id);
    this.formData.sale_id = parseInt(this.$route.query.sale_id);
    let that = this;
    if (this.formData.id > 0) {
      that.fetch();
    }
    that.goodsOptions();
  },
  destroyed() {},
  methods: {
    onGoodsSkuPicker() {
      let that = this;
      this.showSkuPicker = true;
      let sku = {};
      let total = 0;
      this.$api.get(
        "/api/goods/goodsdetail",
        { id: this.formData.goods_id },
        (res) => {
          that.skuData.sku = sku = res.data.sku;
          that.skuData.sku.messages = [];
          that.skuData.goods = {
            title: res.data.data.title,
            picture: res.data.data.pic_url,
          };
          // 总数量
          for (let i = 0; i < sku.list.length; i++) {
            total = total + sku.list[i].stock_num;
          }

          that.skuData.sku.stock_num = total;
          that.skuData.sku.price =
            res.data.data.price_range[0] + "-" + res.data.data.price_range[1];
          that.skuData.goods_id = res.data.data.id;
          that.skuData.quota = res.data.data.user_buy_limit;
          that.skuData.quotaUsed = res.data.data.buy_count;
          that.showSkuPicker = true;
        }
      );
    },
    onGoodsSkuSave(data) {
      let that = this;
      console.log(data.selectedSkuComb);
      let tree = that.skuData.sku.tree;
      let name = "";
      let s = "/";
      data.selectedSkuComb.sku.map((attr, f) => {
        if (f == data.selectedSkuComb.sku.length - 1) {
          s = "";
        }
        tree.map((item, t) => {
          item.v.map((v_item, v) => {
            if (v_item.id == attr.attr_id) {
              name += v_item.name + s;
            }
          });
        });
      });
      this.formData.sku_name=name
      this.formData.sku_id=data.selectedSkuComb.id
      this.formData.goods_count=0
      this.formData.goods_price=data.selectedSkuComb.price/100
      this.showSkuPicker = false;
    },
    onSearchInput(val) {
      console.log(val);
      this.goodsOption = this.goods_list.filter(function (item) {
        return item.title.indexOf(val) == -1 ? false : true; //
      });
    },
    onGoodsChange(item) {
      this.formData.goods_name = item.title;
      this.formData.goods_id = item.id;
      this.formData.sku_name = "";
      this.formData.sku_id = 0;
      this.formData.goods_count = 0;
      this.formData.goods_price = 0;
      this.goods_show = false;
    },
    fetch() {
      this.$api.post(
        "/api/jxc/saleGoodsDetail",
        { id: this.formData.id },
        (res) => {
          console.log(res);
          this.formData.goods_name = res.data.goods_name;
          this.formData.goods_id = res.data.goods_id;
          this.formData.sku_name = res.data.sku_name;
          this.formData.sku_id = res.data.sku_id;
          this.formData.goods_count = res.data.goods_count;
          this.formData.goods_price = res.data.goods_price;
        },
        (err) => {
          Toast.fail(err.msg);
        }
      );
    },
    onSubmit(values) {
      console.log("submit", this.formData);
      let that = this; 
      if (this.formData.id > 0) {
        this.$api.post(
          "/api/jxc/saleGoodsEdit",
          this.formData,
          (res) => {
            console.log(res);
            Toast.success("修改成功");
            this.formData.id = res.data.id;
            that.fetch();
          },
          (err) => {
            Toast.fail(err.msg);
          }
        );
      } else {
        this.$api.post(
          "/api/jxc/saleGoodsAdd",
          this.formData,
          (res) => {
            console.log(res);
            this.formData.id = res.data.id;
            Toast.success("新增成功");
            that.fetch();
          },
          (err) => {
            Toast.fail(err.msg);
          }
        );
      }
    },
    onClsoePopup() {
      this.goods_show = false;
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
    },
    goodsOptions() {
      let that = this;
      this.$api.get(
        "/api/jxc/goodsOptions",
        {},
        (res) => {
          that.goodsOption = res.data;
          that.goods_list = res.data;
        },
        (err) => {
          Toast.fail(err.msg);
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaleGoodsAdd.vue?fdec8dae